export default __webpack_public_path__ + "static/media/i2.b4c647bf.jpg";